module.exports = {
    publicPath: '/',
    // publicPath: '/new/',
    transpileDependencies: ['vuetify', '@geoman-io/leaflet-geoman-free', 'leaflet-arrowheads'],
}
